<div class="default-theme app-shell" data-cy="feature-app-shell">
  <mat-sidenav-container [hasBackdrop]="isSmallScreen()" (backdropClick)="closePreferences()" class="main-container">
    <mat-sidenav
      [mode]="isSmallScreen() ? 'over' : 'side'"
      [opened]="opened()"
      class="navigation-bar h-full w-62.5! pt-2.5"
      data-cy="feature-app-shell-sidenav"
    >
      <div class="box-border flex h-full flex-col justify-between overflow-hidden">
        @if (navigationTree()) {
          <mat-nav-list class="sidenav flex-auto">
            @for (navBlock of navigationTree(); track $index) {
              <iot-platform-ui-sidenav-block data-cy="feature-app-shell-sidenav-block" [navBlock]="navBlock" />
            } @empty {
              ...
            }
          </mat-nav-list>
        }

        <div class="flex flex-col">
          <iot-platform-ui-build-info
            [build]="appConfig.back"
            [label]="'TAB_NAV.BUILD_INFO.BACKEND' | translate"
            [showBuildNumber]="false"
            [showChangelog]="false"
          />
          <iot-platform-ui-build-info
            [build]="appConfig.front"
            [label]="'TAB_NAV.BUILD_INFO.FRONTEND' | translate"
            [showBuildNumber]="false"
            [showChangelog]="true"
            (openChangelog)="openChangelog()"
          />
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="main-sidenav-content" [style.width]="isXSmallScreen() ? 'auto' : sideNavContentWidth()">
      <div class="sticky">
        <oyan-ui-header
          (changeBusinessProfile)="onChangeBusinessProfile($event)"
          (logoClicked)="returnHome()"
          (logout)="logout()"
          (menuClicked)="toggleSidenav()"
          (myProfile)="openMyProfile()"
          [allowRedirectToMyProfile]="settings.allowRedirectToMyProfile"
          [allowSwitchBusinessProfile]="settings.allowSwitchBusinessProfile"
          [businessProfiles]="eligibleBusinessProfiles()"
          [currentUserLoading]="currentUserLoading() || authPending()"
          [currentUser]="currentUser()"
          [appLogo]="settings.appLogo"
          [logoIconName]="settings.logoIconName"
          [selectedBusinessProfile]="businessProfile()"
          data-cy="feature-app-shell-header"
        />
      </div>
      <div class="main-sidenav-body">
        @if (contentReady()) {
          <router-outlet></router-outlet>
        } @else {
          <div class="flex h-full w-full items-center justify-center" data-cy="feature-app-shell-content-loader">
            <mat-spinner diameter="48" />
          </div>
        }
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
